import { idCodec } from "../id/brand.js";
/** The id codec of a website reading (UUID v7, minted in the application). */
export const websiteReadingIdCodec = idCodec("WebsiteReadingId");
/** `website_reading.outcome` (migration 0143's CHECK). */
export const WEBSITE_READING_OUTCOME = ["read", "partial", "failed"];
/** Why one page was not read — shown beside each skipped page (the skip reason). */
export const SKIP_REASON = [
    "robots",
    "noindex",
    "content_type",
    "page_limit",
    "depth_limit",
    "byte_limit",
    "timeout",
    "blocked_address",
    "off_site",
    "duplicate",
    "redirect_limit",
    "no_text",
    "undecodable",
    "error",
];
/** Why a whole reading failed (`website_reading.failure_code`, a closed list). */
export const WEBSITE_FAILURE_CODE = [
    "address_refused",
    "unresolved",
    "blocked_address",
    "unreachable",
    "tls",
    "robots_disallowed",
    "robots_unavailable",
    "timeout",
    "not_html",
    "script_only",
    "no_text",
    "platform",
];
/** Whose fault a failure is: the owner is asked to act on `input`; `platform` is ours. */
export const WEBSITE_FAILURE_FAULT = ["input", "platform"];
//# sourceMappingURL=website-reading.js.map